export enum QueryParamType {
  Number,
  String,
  Email,
}
